import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/BarSorting/editor/barsortingeditor.tsx",
    () => import("./barsortingeditor"),
);
